import { languageSupportCheckout } from '@/constants/language';
import { PATH } from '@/constants/path';
import { ITextTable } from '@/types/components/translation';
import { Badge, Button, IndexTable, InlineStack, Link } from '@shopify/polaris';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const RowData = ({
  dataSource,
  index,
  disabled = false,
}: {
  dataSource: ITextTable;
  index: number;
  disabled?: boolean;
}) => {
  const { name, code, status, files } = dataSource;
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  const requireFilesLength = useMemo(() => (Object.keys(languageSupportCheckout).includes(code) ? 3 : 1), [code]);

  return (
    <>
      <IndexTable.Cell key="trans-name">{name}</IndexTable.Cell>
      <IndexTable.Cell key="trans-code">{code}</IndexTable.Cell>
      <IndexTable.Cell key="trans-status">
        {status ? (
          <Badge tone="success">{t('manageLanguages.translationTable.publishedStatus')}</Badge>
        ) : (
          <Badge>{t('manageLanguages.translationTable.unpublishedStatus')}</Badge>
        )}
      </IndexTable.Cell>
      <IndexTable.Cell key="trans-action">
        <InlineStack blockAlign="center" gap={'100'}>
          <Button variant="plain" onClick={() => navigate(`${PATH.TRANSLATION.pathname}/${code}`)} disabled={disabled}>
            {t('manageLanguages.translationTable.action')}
          </Button>
          {/* {files.length !== requireFilesLength && (
            <Tooltip content={t('manageLanguages.translationTable.warningTooltip')} width="wide">
              <Box>
                <Icon source={AlertTriangleIcon} />
              </Box>
            </Tooltip>
          )} */}
        </InlineStack>
      </IndexTable.Cell>
    </>
  );
};
